import * as React from 'react';
import { JsonLdResult } from 'vet-bones/utils';
import { requestStardogVoiceboxGenesis } from 'vet-bones/utils/voicebox';

import { notificationsActionCreators } from 'src/actions/notifications/actionCreators';
import { projectSelector } from 'src/selectors/project';
import { useDefaultPortalConnection } from 'src/utils/hooks/useDefaultPortalConnection';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';
import { buildGenerateDataModelParameters } from 'src/utils/voicebox/hooks/parameters';
import {
  GenerateDataModelRequest,
  GenerateDataModelResponse,
} from 'src/utils/voicebox/hooks/types';

export const useGenerateDataModel = () => {
  const dispatch = useReduxDispatch();
  const defaultConnection = useDefaultPortalConnection();
  const { projectId } = useRouterParams();
  const project = useReduxSelector(projectSelector(projectId));

  return React.useCallback(async (): Promise<JsonLdResult[] | null> => {
    if (!defaultConnection || !project) {
      return null;
    }

    try {
      const response = await requestStardogVoiceboxGenesis<
        GenerateDataModelRequest,
        GenerateDataModelResponse
      >({
        connectionIdx: defaultConnection.index,
        body: {
          endpoint: defaultConnection.endpoint,
          action: 'generate_data_model',
          parameters: buildGenerateDataModelParameters({
            project,
          }),
        },
      });

      if (response.error) {
        throw new Error(response.error);
      }

      return response.results?.model || null;
    } catch (err) {
      dispatch(notificationsActionCreators.voiceboxGenerateDataModelFailed());
      return null;
    }
  }, [defaultConnection, dispatch, project]);
};
